import { render, staticRenderFns } from "./PreviewCheckboxTree.vue?vue&type=template&id=1c28ab11&"
import script from "./PreviewCheckboxTree.vue?vue&type=script&lang=js&"
export * from "./PreviewCheckboxTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports